import React, {useState} from "react";
import {db} from "../firebase";
import {collection, addDoc} from "firebase/firestore";
import "../style/inquiry-form.css";

function formatPhoneNumber(text: string): string {
  const isSeoulNZ = text.slice(0, 2) === "02";
  const nationZoneRgex = isSeoulNZ ? "(\\d{1,2})" : "(\\d{1,3})";
  const phonePattern = new RegExp(`^${nationZoneRgex}(\\d{0,4})(\\d{0,4}).*$`);

  return text
    .replace(/[^0-9]/g, "")
    .replace(phonePattern, "$1-$2-$3")
    .replace(/^-/, "")
    .replace(/-$/, "")
    .replace(/-$/, "");
}

const InquiryForm: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [content, setContent] = useState("");

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/[^0-9]/g, "");
    setPhone(input);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (phone.trim() === "" || content.trim() === "") {
      alert("전화번호와 문의 내용을 입력해주세요.");
      return;
    }

    if (content.length > 500) {
      alert("문의 내용은 최대 500자까지 입력 가능합니다.");
      return;
    }

    try {
      const inquiryCollection = collection(db, "realtime_inquiry");
      await addDoc(inquiryCollection, {
        phone,
        content,
        createdAt: Date.now(),
      });
      alert("문의가 접수되었습니다!");
      setPhone("");
      setContent("");
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다. 아래 전화번호로 연락주세요. \n 010-7772-9598");
    }
  };

  return (
    <form className={'inquiry-form'} onSubmit={handleSubmit}>
      <div className={'inquiry-field'}>
        <label className={'inquiry-label'}>연락받으실 번호</label>
        <input
          className={'inquiry-input'}
          type="text"
          value={formatPhoneNumber(phone)}
          onChange={handlePhoneChange}
          placeholder={'숫자만 입력해주세요. ex) 01012345678'}
          required
        />
      </div>
      <div className={'inquiry-field'}>
        <label className={'inquiry-label'}>문의 내용</label>
        <textarea
          className={'inquiry-input textarea'}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          maxLength={500}
          placeholder={'궁금하신 점을 적어주세요. (최대 500자)'}
          required
        />
      </div>
      <button className={'inquiry-button'} type="submit"
              disabled={phone.trim() === "" || content.trim() === ""}>
        접수하기
      </button>
    </form>
  );
};

export default InquiryForm;
